export default "__VITE_ASSET__432c456b__"